import React from 'react';
import Box from '@mui/material/Box';
import type {FCWithChildren} from 'types';
import type {LoadStatus} from 'api/types';
import {SceneError} from './SceneError';
import {SceneLoader} from './SceneLoader';

const SceneContentName = 'SceneContentName';

type Props = {
  loadStatus?: LoadStatus;
  error?: string;
  loadingType?: string;
};

const SceneContent: FCWithChildren<Props> = ({
  loadStatus,
  error,
  loadingType,
  children,
}) => {
  if (loadStatus === 'NotLoaded' || loadStatus === 'Loading') {
    return <SceneLoader loadingType={loadingType} />;
  }

  if (loadStatus === 'Failed') {
    return <SceneError error={error} />;
  }

  return <Box id="scene-content">{children}</Box>;
};

SceneContent.displayName = SceneContentName;

export {SceneContent, SceneContentName};
